import React, {Component} from 'react';
import '../styles/Home.css'
import Wyszukiwarka from "../wyszukiwarka/Wyszukiwarka";
import AplikacjaMobilna from "./homeComponents/AplikacjaMobilna";
import Onas from "./homeComponents/Onas";
import Mapa from "./homeComponents/Mapa";
import Footer from "../shared/Footer";
import Slider from "./homeComponents/Slider";
import Newsletter from "./homeComponents/Newsletter";
import {confirmAlert} from "react-confirm-alert";

export default class Home extends Component {

    componentDidMount() {


        console.log('test konsoli')

        let userAgent = navigator.userAgent || navigator.vendor || window.opera;


        if (/android/i.test(userAgent)) {

            confirmAlert({
                title: 'Aplikacja mobilna Marcel Bus',
                message: 'Pobierz ze sklepu bezpłatną aplikację Marcel Bus na Androida i uzyskaj jeszcze szybszy dostęp do swoich biletów.',
                buttons: [
                    {
                        label: 'Przedź do sklepu',
                        onClick: () =>  window.location.replace('https://play.google.com/store/apps/details?id=com.react_marcel&hl=pl')
                    },
                    {
                        label: 'Powrót',
                        onClick: () => console.log('Zamknięto komunikat.')
                    }
                ]
            });
        }
        this.miejsceInput.focus()
        window.scrollTo(0,0)
    }

    render() {
        return <div className="home">
            <Slider/>
            <div className="container wyszukiwarkaContainer">
                <div className="wyszukiwarka">
                    <Wyszukiwarka miejsceInput={ref => (this.miejsceInput = ref)} onButtonClick={() => {
                    }} setButtonLoader={() => {
                    }}/>
                </div>
            </div>
            <Onas/>
            <Mapa/>
            <Newsletter/>
            <AplikacjaMobilna/>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/Home.js